import { useQuery } from '@tanstack/react-query'
import { request } from 'utils/request'

import { HOMEPAGE_SLIDER_URL, SLIDER_CACHE_TIME } from './constants'
import { slidesSchema } from './validation'

export function useHomepageSlides() {
  const { data: slides } = useQuery({
    queryKey: ['homepage', 'slider'],
    queryFn: getSlider,
    gcTime: SLIDER_CACHE_TIME,
    staleTime: SLIDER_CACHE_TIME,
  })

  return { slides }
}

async function getSlider() {
  const { data } = await request(HOMEPAGE_SLIDER_URL)

  return slidesSchema.parse(data)
}
